import firebase from "firebase/app";
import "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDClQ79oKD0KmOeaDF6lnrWokjZwcerI6E",
  authDomain: "mondial-d753d.firebaseapp.com",
  projectId: "mondial-d753d",
  storageBucket: "mondial-d753d.appspot.com",
  messagingSenderId: "938407506868",
  appId: "1:938407506868:web:5ff4322616380fa61938e1",
};
// Initialize Firebase
let region: string | undefined = "europe-west1";
firebase.initializeApp(firebaseConfig);
if (process.env.NODE_ENV === "development") {
  firebase.app().functions().useEmulator("localhost", 5001);
  region = undefined;
}

export const getRegion = () => region;

export default firebase;
